import React, { useState } from "react";
import { Box, Button, Container, Link, Stack, Text } from "@chakra-ui/react";
import { OrangeLines } from "../../atoms/OrangeLines";
import { Involved } from "../../molecules/PopUps/GetInvolved";
import { Impact } from "../PopUps/Impact";

type OrangeProps = {
  showInvolved: boolean;
  showImpact: boolean;
};

const sop = (
  <Text>
    If you are interested in collaboration as a <b>Sponsor or Partner</b>,
    kindly fill out the form below. Thank You!
  </Text>
);
export const Orange = ({
  bg,
  text,
  subText,
  textColor,
  buttonText,
  buttonColor,
  href,
  showInvolved,
  showImpact,
}: any) => {
  return (
    <Box
      as="section"
      bg={bg}
      pos="relative"
      h={{ base: "auto", md: "438px" }}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <OrangeLines
        pos="absolute"
        top={0}
        left={0}
        w={{ base: "100%", md: "100%" }}
      />
      <Container
        maxW={{ base: "3xl", md: "7xl" }}
        py="7.5rem"
        display="flex"
        justifyContent="center"
      >
        <Stack
          spacing={{ base: "8", md: "10" }}
          maxW={{ base: "343px", md: "100%" }}
        >
          <Stack spacing={{ base: "4", md: "none" }} align="center">
            <Text
              textAlign="center"
              fontFamily={"TradeGothic LT Bold"}
              fontSize={{ base: "4xl", md: "5xl" }}
              fontWeight="700"
              lineHeight="115%"
              color={textColor}
              textTransform="uppercase"
            >
              {text}
            </Text>
            <Text
              w={{ base: "auto", md: "690px" }}
              color="white"
              textAlign={"center"}
            >
              {subText}
            </Text>
          </Stack>
          <Stack
            spacing="3"
            direction={{ base: "column", sm: "row" }}
            justify="center"
          >
            {showInvolved ? (
              <Button
                size="xl"
                textTransform="uppercase"
                bg="white"
                color={buttonColor}
                borderRadius={0}
                fontSize="lg"
                fontFamily={"TradeGothic LT Bold"}
                fontWeight={700}
                lineHeight="150%"
                px={8}
                h={12}
                aria-label="involved"
              >
                <Involved
                  button={"apply"}
                  title={"Get involved & volunteer"}
                  text={
                    "If you think you might have a little time to assist us, kindly fill out the form below."
                  }
                  thanks={"Thank You!"}
                />
              </Button>
            ) : (
              <Link display="flex" justifyContent="center" href={href} _hover={{ textDecoration: "none" }}>
                <Button
                  size="xl"
                  textTransform="uppercase"
                  bg="white"
                  color={buttonColor}
                  borderRadius={0}
                  fontSize="lg"
                  fontFamily={"TradeGothic LT Bold"}
                  fontWeight={700}
                  lineHeight="150%"
                  px={8}
                  h={12}
                  aria-label="apply-button"
                >
                  {buttonText}
                </Button>
              </Link>
            )}
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};
